import classnames from 'classnames';
import React, { Component } from 'react';
import Chart from 'react-google-charts';
import { Button, ButtonGroup, Col, Progress, Row, TabContent, TabPane } from 'reactstrap';
import DeliverySummaryList from './DeliverySummaryList';
import FailureSummaryList from './FailureSummaryList';
import { orderBy } from 'lodash';

class FaxesReportTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFaxTab: 'deliverySummary',
      sort: {
        name: '',
        order: '',
      },
    };
    global.activeStatTab = 'deliverySummary';
  }

  async onDownload(id) {}

  async onDelete() {}

  async onSendFax(fax) {}

  handleChangePagination = async numPage => {};

  handleSetLimit = async limit => {};

  setActiveFaxTab = e => {
    this.setState({ activeFaxTab: e });
    global.activeStatTab = e;
  };

  handleSortFax = filter => {
    const { sort } = this.state;
    const updateSort = { ...sort };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    this.setState({ sort: updateSort });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;

    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(array, [el => el[sortNameArr[0]][sortNameArr[1]].toLowerCase()], [sort.order]);
    } else if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    } else {
      return orderBy(array, [el => el[sort.name]], [sort.order]);
    }
  };

  render() {
    const { faxes, failure } = this.props;

    var title = '';
    var faxData = faxes;
    var totalFaxes = 0;
    var totalSuccess = 0;
    var totalFail = 0;
    var totalSuccessPercent = 0;
    var totalFailPercent = 0;

    if (this.state.activeFaxTab !== 'deliverySummary') {
      title = 'Failure Chart';
    } else {
      title = 'Success/Failure Chart';
    }

    const options = {
      chartArea: {
        top: 20,
        bottom: 60,
        left: 60,
        right: 30,
      },
      seriesType: 'bars',
      series: { 1: { type: 'line' } },
      legend: { position: 'none' },
      colors: ['#4285f4', '#28a745', '#db4437'],
    };

    this.chartData = [['', 'Total', 'Success', 'Failure']];

    if (faxes.length === 0) {
      this.chartData.push(['No data', 0, 0, 0]);
    } else {
      faxData.forEach(item => {
        totalFaxes = totalFaxes + item.totalFaxes;
        totalSuccess = totalSuccess + item.success;
        totalFail = totalFail + item.failure;

        this.chartData.push([item.shortDate, item.totalFaxes, item.success, item.failure]);
      });
    }

    totalSuccessPercent = (totalSuccess / totalFaxes) * 100;
    totalFailPercent = (totalFail / totalFaxes) * 100;

    const { sort } = this.state;
    const renderList = sort.name.length ? faxes?.length && this.sortColumnByKey(faxes) : faxes;
    const renderFailureList = sort.name.length
      ? failure?.length && this.sortColumnByKey(failure)
      : failure;
    return (
      <div>
        <ButtonGroup className="tab-group">
          <Button
            className={classnames({ active: this.state.activeFaxTab === 'deliverySummary' })}
            onClick={() => {
              this.setActiveFaxTab('deliverySummary');
            }}
          >
            Delivery Summary
          </Button>

          <Button
            className={classnames({
              active: this.state.activeFaxTab === 'failureSummary',
            })}
            onClick={() => {
              this.setActiveFaxTab('failureSummary');
            }}
          >
            Failure Summary
          </Button>
        </ButtonGroup>

        <Row className="stat-table-container">
          <Col md="5" sm="12">
            <TabContent activeTab={this.state.activeFaxTab}>
              <TabPane tabId="deliverySummary">
                <Row>
                  <Col md={12}>
                    <div className="viewContainer">
                      <DeliverySummaryList
                        faxes={renderList}
                        sortValue={sort}
                        onSort={this.handleSortFax}
                      />
                    </div>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="failureSummary">
                <Row>
                  <Col md={12}>
                    <div className="viewContainer">
                      <FailureSummaryList
                        faxes={renderFailureList}
                        sortValue={sort}
                        onSort={this.handleSortFax}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    {/* {
                  faxes.incomingFaxes.totalPages > 1 &&
                  <Pagination
                    className="pagination-container"
                    onChange={this.handleChangePagination}
                    current={faxes.incomingFaxes.page}
                    total={faxes.incomingFaxes.totalDocs}
                    pageSize={faxes.incomingFaxes.limit}
                    showLessItems
                  />
                } */}
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>

          <Col md="7" sm="12">
            <Row>
              <Col md="12">
                <div className="viewContainer" style={{ padding: '10px' }}>
                  <h6 style={{ margin: '20px', textAlign: 'left' }}>{title}</h6>
                  <hr />
                  <Chart
                    width={'100%'}
                    height={'250px'}
                    chartType="Bar"
                    loader={<div>Loading Data</div>}
                    data={this.chartData}
                    options={options}
                    rootProps={{ 'data-testid': '1' }}
                  />
                </div>
              </Col>

              {this.state.activeFaxTab === 'deliverySummary' ? (
                <Col md="12">
                  <div className="viewContainer">
                    <h6 style={{ margin: '20px', textAlign: 'left' }}>Total Faxes</h6>
                    <hr />
                    <Row>
                      <Col md="6" sm="12">
                        <div className="bar-container">
                          <div className="bar-top">
                            <div className="bar-title">Delivered</div>
                          </div>
                          <div
                            className="bar-limit"
                            style={{ width: `${(totalSuccessPercent - 2).toString()}%` }}
                          >
                            <div
                              className="bar-value"
                              style={
                                totalSuccessPercent < 22
                                  ? { marginRight: '-100px' }
                                  : { marginRight: '-20px' }
                              }
                            >
                              ({totalSuccess})
                            </div>
                          </div>
                          <div>
                            <Progress color="success" value={totalSuccessPercent} />
                          </div>
                          <div className="bar-bottom">{totalFaxes}</div>
                        </div>
                      </Col>
                      <Col md="6" sm="12">
                        <div className="bar-container" style={{ margin: '0px 20px 0px 20px' }}>
                          <div className="bar-top">
                            <div className="bar-title">Failure</div>
                          </div>
                          <div
                            className="bar-limit"
                            style={{ width: `${(totalFailPercent - 2).toString()}%` }}
                          >
                            <div
                              className="bar-value"
                              style={
                                totalFailPercent < 22
                                  ? { marginRight: '-76px' }
                                  : { marginRight: '-52px' }
                              }
                            >
                              ({totalFail})
                            </div>
                          </div>
                          <div>
                            <Progress color="danger" value={totalFailPercent} />
                          </div>
                          <div className="bar-bottom">{totalFaxes}</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ) : null}
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default FaxesReportTab;
